// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__+GTKs","modal__title":"styles_modal__title__UNv+s","modal__footer":"styles_modal__footer__-Q1nh"};